module.exports = __webpack_public_path__ + "creativeDigitalLogo2.c949157a278d604c3add.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/creativeDigitalLogo2.png
// module id = ../../../../../src/assets/creativeDigitalLogo2.png
// module chunks = 0